// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IIsPayClaimsOutsideCoveragePropertyDto
 */
export interface IIsPayClaimsOutsideCoveragePropertyDto {
    /**
     * 
     * @type {boolean}
     * @memberof IIsPayClaimsOutsideCoveragePropertyDto
     */
    is_pay_claims_outside_coverage?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IIsPayClaimsOutsideCoveragePropertyDto
     */
    is_pay_claims_outside_coverage_state?: IIsPayClaimsOutsideCoveragePropertyDtoIsPayClaimsOutsideCoverageStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IIsPayClaimsOutsideCoveragePropertyDtoIsPayClaimsOutsideCoverageStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IIsPayClaimsOutsideCoveragePropertyDto interface.
 */
export function instanceOfIIsPayClaimsOutsideCoveragePropertyDto(value: object): value is IIsPayClaimsOutsideCoveragePropertyDto {
    return true;
}

export function IIsPayClaimsOutsideCoveragePropertyDtoFromJSON(json: any): IIsPayClaimsOutsideCoveragePropertyDto {
    return IIsPayClaimsOutsideCoveragePropertyDtoFromJSONTyped(json, false);
}

export function IIsPayClaimsOutsideCoveragePropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IIsPayClaimsOutsideCoveragePropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'is_pay_claims_outside_coverage': json['is_pay_claims_outside_coverage'] == null ? undefined : json['is_pay_claims_outside_coverage'],
        'is_pay_claims_outside_coverage_state': json['is_pay_claims_outside_coverage_state'] == null ? undefined : json['is_pay_claims_outside_coverage_state'],
    };
}

export function IIsPayClaimsOutsideCoveragePropertyDtoToJSON(json: any): IIsPayClaimsOutsideCoveragePropertyDto {
    return IIsPayClaimsOutsideCoveragePropertyDtoToJSONTyped(json, false);
}

export function IIsPayClaimsOutsideCoveragePropertyDtoToJSONTyped(value?: IIsPayClaimsOutsideCoveragePropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'is_pay_claims_outside_coverage': value['is_pay_claims_outside_coverage'],
        'is_pay_claims_outside_coverage_state': value['is_pay_claims_outside_coverage_state'],
    };
}

